import CloudCannonApi from '@api/CloudCannonApi'
import { errToString } from '@utils'

export default {
  data() {
    return {
      group_title_header_html: '',
      group_info_header_html: '',
      billing_info_header_html: '',
      internalMembership_header_html: '',
      internalMembership_cobra_header_html: '',
      externalMembership_header_html: '',
      externalMembership_cobra_header_html: '',
      eyeManage_header_html: '',
      personal_header_html: '',
      final_page_html: ''
    }
  },
  created() {
    new CloudCannonApi()
      .getCloudCannonContent({
        cloudCannonResource: '/client-onboard-verbiage.json'
      })
      .then(response => {
        this.group_title_header_html = response.group_title_header_html
        this.group_info_header_html = response.group_info_header_html
        this.billing_info_header_html = response.billing_info_header_html
        this.internalMembership_header_html = response.internalMembership_header_html
        this.internalMembership_cobra_header_html = response.internalMembership_cobra_header_html
        this.externalMembership_header_html = response.externalMembership_header_html
        this.externalMembership_cobra_header_html = response.externalMembership_cobra_header_html
        this.eyeManage_header_html = response.eyeManage_header_html
        this.personal_header_html = response.personal_header_html
        this.final_page_html = response.final_page_html
      })
      .catch(err => {
        errToString(err)
          .then((errStr) => {
            console.error(errStr)
          })
      })
  }
}
